module.exports = __webpack_public_path__ + "static/strongyogi_logo-1dcc6c79101db4bb790a4a82dbfffe50.svg";